import { FuelButton, FuelTooltip } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { DS_TOKENS } from 'constants/styled.contants';
import ChatNotificationButton from 'externals/ChatNotificationButton';
import { ITruckerProfileProps } from 'interfaces/profile.interface';
import { ButtonCustomProps, TRiskManagementProps } from 'open-search/types';
import React from 'react';

interface IActions {
  riskManagement: TRiskManagementProps;
  openTruckerProfileButtonProps: ButtonCustomProps;
  openSearchWidth: number;
  hasChatButton: boolean;
  searchedTrucker: ITruckerProfileProps;
}

const Actions = ({
  riskManagement,
  openTruckerProfileButtonProps,
  hasChatButton,
  searchedTrucker,
  openSearchWidth,
}: IActions) => (
  <FuelFlex
    defaultProps={{
      gap: 'km4',
      alignItems: 'center',
      customMargin: `${DS_TOKENS.spacing.km2} 0`,
    }}
  >
    {hasChatButton && (
      <ChatNotificationButton
        source="open-search"
        truckerUuid={searchedTrucker?.trucker?.uuid}
        truckerName={searchedTrucker?.trucker?.name}
        withBorder
        hasSendMessageTooltip
        buttonSize="medium"
      />
    )}
    {riskManagement.buttonRiskManagement.states.isVisible && !hasChatButton && (
      <FuelButton
        variant="secondary"
        size="medium"
        data-testid="risk-management-button"
        onClick={riskManagement.buttonRiskManagement.events.onClick}
      >
        {riskManagement.buttonRiskManagement.states.textContent}
      </FuelButton>
    )}
    {riskManagement.buttonRiskManagement.states.isVisible && hasChatButton && (
      <FuelTooltip placement="top-start" content={riskManagement.buttonRiskManagement.states.textContent}>
        <FuelButton
          variant="secondary"
          size="medium"
          data-testid="risk-management-button"
          onClick={riskManagement.buttonRiskManagement.events.onClick}
          onlyIcon={openSearchWidth < 400}
          trailingIcon={openSearchWidth < 400 ? 'risk-management' : null}
        >
          {riskManagement.buttonRiskManagement.states.textContent}
        </FuelButton>
      </FuelTooltip>
    )}

    <FuelButton
      variant="primary"
      data-testid="open-trucker-profile-button"
      onClick={openTruckerProfileButtonProps.events.onClick}
      fullWidth
    >
      {openTruckerProfileButtonProps.states.textContentMobile}
    </FuelButton>
  </FuelFlex>
);

export default Actions;
